// NOTE: This require will be replaced with `@sentry/browser` when
// process.browser === true thanks to the webpack config in next.config.js
import * as Sentry from "@sentry/node";
import { getDecodedIdToken } from "lib/auth";

class UserIntegration {
  name = "UserIntegration";
  id = "UserIntegration";

  setupOnce() {
    Sentry.addGlobalEventProcessor(async (event, hint) => {
      try {
        const ctx = event.extra?.initialPropsCtx;
        if (ctx?.req) {
          event.user = {
            ip_address: ctx.req.headers["x-forwarded-for"],
          };
        }

        const user = await getDecodedIdToken(ctx);
        if (user) {
          event.user = { ...event.user, email: user.email };
        }
      } catch (e) {
        console.error(e);
      }

      return event;
    });
  }
}

export default UserIntegration;
